import Modal from "react-modal";
import "./address-modal.css";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import { Button, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useEffect } from "react";

function AddressModalComponent({
  isOpen,
  address,
  closeModal,
  addToAddresses,
}) {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: "20",
    },
  };

  const [addressBody, setAddressBody] = useState({});

  useEffect(() => {
    if (address) {
      setAddressBody(address);
    }
  }, [address]);

  useEffect(() => {
    if (!isOpen) {
      setAddressBody({});
    }
  }, [isOpen]);

  const addToKart = useShoppingKartStore((state) => state.addToKart);

  const createAddress = () => {
    const userId = localStorage.getItem("userId");
    let fetchData = {
      method: "POST",
      body: JSON.stringify({ ...addressBody, user: userId }),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/addresses", fetchData)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        addToAddresses(res);
        closeModal();
      });
  };

  const updateAddress = () => {
    let fetchData = {
      method: "PUT",
      body: JSON.stringify({ ...addressBody }),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/addresses", fetchData)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        closeModal();
      });
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
      <div className="address-modal-container">
        <h2 style={{ marginBottom: "15px" }}>
          {address ? "Editar dirección" : "Nueva dirección"}
        </h2>
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Nombre del destinatario"
          type="text"
          value={addressBody.clientName}
          onChange={(e) =>
            setAddressBody({ ...addressBody, clientName: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Apellido del destinatario"
          type="text"
          value={addressBody.clientLastName}
          onChange={(e) =>
            setAddressBody({ ...addressBody, clientLastName: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Número de teléfono"
          type="text"
          value={addressBody.clientCellphone}
          onChange={(e) =>
            setAddressBody({ ...addressBody, clientCellphone: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Nombre de la calle"
          type="text"
          value={addressBody.streetName}
          onChange={(e) =>
            setAddressBody({ ...addressBody, streetName: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Número de casa"
          type="text"
          value={addressBody.houseNumber}
          onChange={(e) =>
            setAddressBody({ ...addressBody, houseNumber: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Referencia (color de casa, etc)"
          type="text"
          value={addressBody.reference}
          onChange={(e) =>
            setAddressBody({ ...addressBody, reference: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Fraccionamiento"
          type="text"
          value={addressBody.neighbourhood}
          onChange={(e) =>
            setAddressBody({ ...addressBody, neighbourhood: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Código postal"
          type="text"
          value={addressBody.postalCode}
          onChange={(e) =>
            setAddressBody({ ...addressBody, postalCode: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Ciudad"
          type="text"
          value={addressBody.city}
          onChange={(e) =>
            setAddressBody({ ...addressBody, city: e.target.value })
          }
        />
        <TextField
          style={{ width: "calc(50% - 10px)", margin: "5px" }}
          variant="outlined"
          label="Estado"
          type="text"
          value={addressBody.state}
          onChange={(e) =>
            setAddressBody({ ...addressBody, state: e.target.value })
          }
        />
        <Button
          onClick={() => {
            addressBody.id ? updateAddress() : createAddress();
          }}
        >
          {" "}
          Click{" "}
        </Button>
      </div>
    </Modal>
  );
}

export default AddressModalComponent;
